<template>
  <option :value="value">
    {{ label }}
  </option>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  option:checked {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
